export enum UserType {
  LoggedOnOnly,
  AllUsers,
}
